import { Link } from "react-router-dom";
const LandingPage = () => {
  return (
    <>
      <h1>Expense Tracker</h1>
      <Link to="/Login">
        <button className="login-btn">Login</button>
      </Link>
      <Link to="/Register">
        <button className="register-btn">Register</button>
      </Link>
    </>
  );
};
export default LandingPage;
